import toast from '@components/Common/Toast.js';
import { UICheckbox, UIDiv } from '@ui';
import { updateColumnValue } from '@utils/columnUtils.js';

export default class CheckboxCell extends UIDiv {
  constructor(
    column,
    item = {},
    value = '',
    canEdit = true,
    onValueChange = null,
  ) {
    super();

    this.column = column;
    this.item = item;
    this.value = value;
    this.isEditMode = false;
    this.canEdit = canEdit;
    this.onValueChange = onValueChange; // Callback for value changes instead of API calls
    this.setClass('flex h-full align-center justify-center');
    this.render();
  }

  render() {
    this.clear();
    this.renderCheckbox();
  }

  renderCheckbox() {
    const checkbox = new UICheckbox('', this.value, false);
    checkbox.input.setAttribute('tabindex', '0');
    checkbox.input.className =
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500';
    checkbox.input.onkeydown = event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkbox.input.click(); // Trigger click on Enter key
      }
    };
    checkbox.addClass('min-h-[34px]');
    if (this.canEdit) {
      checkbox.onChange(async e => {
        const newValue = e.target.checked;
        try {
          // If onValueChange callback is provided, use it instead of API call
          if (this.onValueChange) {
            this.onValueChange(newValue);
            // Update the local value
            this.value = newValue;
          } else {
            // Update the value via API if we have the necessary information
            const entityType = !this.item.reconstructions ? 'folder' : 'file';
            const entityId = this.item.id || this.item.sharingId;

            await updateColumnValue(
              this.column.id,
              entityType,
              entityId,
              newValue,
            );

            // Update the local value
            this.value = newValue;
            if (this.item) {
              this.item[this.column.key] = newValue;
            }
          }
        } catch (error) {
          console.error('Failed to update column value:', error);
          toast.error(i18next.t('pages.projects.toast.failed_column_update'));
        }
      });
    } else {
      checkbox.setDisabled(true);
    }

    this.add(checkbox);
  }
}
